import { render, staticRenderFns } from "./CodeTab.vue?vue&type=template&id=118e1c2b&"
import script from "./CodeTab.vue?vue&type=script&lang=js&"
export * from "./CodeTab.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/components/code-tab.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports